import React, { useRef } from 'react';
import { useSmartScroll } from '../../hooks/useSmartScroll';
import '../../App.css';

/**
 * Recording UI for both audio and video
 * Shows recording preview, waveform, and controls
 * Automatically scrolls into view when recording starts (unless disableAutoScroll is true)
 */
function RecordingSection({ type, recording, formatDuration, promptText, disableAutoScroll = false }) {
  const containerRef = useRef(null);
  const promptBoxRef = useRef(null);

  // Auto-scroll the prompt box (or container) into view when recording starts
  // Can be disabled when parent component handles its own scrolling (e.g., Studio)
  useSmartScroll({ targetRef: promptBoxRef, fallbackRef: containerRef, autoScroll: !disableAutoScroll });

  if (type === 'video') {
    return (
      <div>
        {promptText && (
          <div
            ref={promptBoxRef}
            className="recording-prompt-box"
          >
            {promptText}
          </div>
        )}
        <div ref={containerRef} className="recording-container">
          <video
            ref={recording.setVideoRef || recording.videoRef}
            autoPlay
            muted
            style={{ width: '100%', maxHeight: '400px', background: '#000' }}
          />
          <div className="recording-controls">
            <button
              className="btn-stop-recording"
              onClick={recording.stop}
            >
              ⏹ Stop Recording
            </button>
            <button
              className="btn-pause-recording"
              onClick={recording.isPaused ? recording.resume : recording.pause}
            >
              {recording.isPaused ? '▶ Continue Recording' : '⏸ Pause Recording'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Audio recording
  return (
    <div>
      {promptText && (
        <div
          ref={promptBoxRef}
          className="recording-prompt-box"
        >
          {promptText}
        </div>
      )}
      <div ref={containerRef} className="recording-container">
        <div style={{ textAlign: 'center', marginBottom: '0.5rem', fontSize: '1.2rem', fontWeight: 'bold' }}>
          {recording.isPaused ? '⏸ Paused' : '🔴 Recording'} {formatDuration(recording.duration)}
        </div>
        <canvas
          ref={recording.canvasRef}
          width="800"
          height="100"
          style={{ width: '100%', borderRadius: '0.5rem' }}
        />
        <div className="recording-controls">
          <button
            className="btn-stop-recording"
            onClick={recording.stop}
          >
            ⏹ Stop Recording
          </button>
          <button
            className="btn-pause-recording"
            onClick={recording.isPaused ? recording.resume : recording.pause}
          >
            {recording.isPaused ? '▶ Continue Recording' : '⏸ Pause Recording'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RecordingSection;
